module.exports = __webpack_public_path__ + "static/media/star.18e67fe8.webp";